module.exports = __webpack_public_path__ + "media/images/img/tag_company/skylight_tag-313e09d3c30b50f6002d4fd1770edf44.png";